
import service from '@/utils/request'

/**
 * @description: 获取锐明平台用户API管理第三方页面URL
 * @return {string} 第三方页面URL
 */
export const getExtUserApiManagePageAPI = (): Promise<any> => {
  return service.request({
    url: '/alpha/extPageApiusermanagement',
    method: 'post',
    data: {}
  })
}
